import walletTransactionType from "./walletTransactionTypes";

const initialState = {
  loading: false,
  filterWalletTransactions: [],
};

export default function walletTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case walletTransactionType.FILTER_WALLET_TRANSACTION:
      return {
        ...state,
        filterWalletTransactions: action.payLoad?.data?.data || [],
      };

    case walletTransactionType.LOADING_WALLET_TRANSACTION:
      return {
        ...state,
        loading: action.payLoad,
      };
    default:
      return state;
  }
}
